import { motion } from "framer-motion";
import { CalendarCheck, Search, Sparkles } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { EditorialHeading } from "./Reveal";

const ICONS = [CalendarCheck, Search, Sparkles];

export const Process = () => {
  const { t } = useLang();
  return (
    <section id="process" data-testid="process-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <EditorialHeading kicker={t.process.kicker} lines={t.process.lines} size="text-4xl sm:text-5xl lg:text-6xl" />

        <div className="mt-16 relative grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="hidden md:block absolute top-6 left-[16%] right-[16%] h-px bg-gradient-to-r from-[#c0c0c0] via-[#ff6b00]/50 to-[#c0c0c0]" aria-hidden="true" />
          {t.process.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.18 }}
                className="relative text-center md:px-6"
              >
                <span className="relative z-10 inline-flex w-12 h-12 rounded-full bg-gradient-to-br from-[#ff6b00] to-[#ffd700] items-center justify-center shadow-lg shadow-orange-200 mb-6">
                  <Icon size={20} className="text-white" />
                </span>
                <p className="font-display text-5xl text-[#e5e1d9] select-none absolute -top-4 left-1/2 -translate-x-1/2 -z-0">0{i + 1}</p>
                <h3 className="font-display text-xl sm:text-2xl text-neutral-900 mb-3">{s.title}</h3>
                <p className="text-sm text-neutral-500 leading-relaxed max-w-xs mx-auto">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
